import {
  Box,
  Flex,
  Spinner,
  Text,
  Center,
  Button,
  Divider,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';
import { MdArrowForward } from 'react-icons/md';
import { Formik, Form } from 'formik';
import OrderApi from 'api/orders';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { CspStatus } from 'config/constant';
import MultiLineSelectField from 'components/formComponents/multiLineSelectField';
import Card from 'components/card/Card';
import CustomerSavingPlanApi from 'api/customersavingplan';
import InstallmentsTable from './components/installmentsTable';
import { OrderSummaryPage } from '../components/OrderSummary';
import StoresApi from 'api/stores';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import { isValidUUID } from 'utils/fetchUtils';
import PageError from 'components/nopermission/PageError';

const CustomerSavingPlan = () => {
  const [planData, setPlanData] = useState({});
  const [loading, setLoading] = useState(false);
  const [virtualAccountLoading, setVirtualAccountLoading] = useState(false);
  const toast = useToast();
  const toastIdRef = React.useRef();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [orderSummary, setOrdersummary] = useState();
  const [stores, setStores] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [error, setError] = useState('');
  const planId = IdFromUrl(window.location.href);
  const { getPermissionsForModule } = usePermissions();
  const [permissions, setPermissions] = useState(null);
  const [
    fetchCustomerSavingPlanDataError,
    setFetchCustomerSavingPlanDataError,
  ] = useState(false);

  useEffect(() => {
    const permissions = getPermissionsForModule([
      Modules.CustomerSavingPlans,
      Modules.MakerCheckers,
    ]);
    setPermissions(permissions);
  }, []);

  function IdFromUrl(url) {
    const parts = url.split('/');
    const id = parts[parts.length - 1];
    return id;
  }
  const storeOptions = stores.map((branch) => ({
    value: branch.id,
    titleLabel: `${branch.name} (${branch.store_code})`,
    // subLabel: branch.address_line1,
    bodyLabel: `${branch.city} ${branch.state} ${branch.pincode}`,
  }));

  console.log('here is plan Id-', planId);

  const GoToCustomerUser = (id) => {
    const url = `/admin/customeruser/${id}`;
    window.open(url, '_blank');
  };

  const GoToStore = (id) => {
    const url = `/admin/store/${id}`;
    window.open(url, '_blank');
  };

  const CreateVirtualAccount = async () => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    setVirtualAccountLoading(true);
    try {
      let response = await CustomerSavingPlanApi.CreateVirtualAccount(planId);
      response = response.data;
      console.log('response from Customer Saving Plan Installment -', response);
      setVirtualAccountLoading(false);
      if (response.status_code === 200) {
        toastIdRef.current = toast({
          title: response.message || 'Virtual Account Created Successfully',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        FetchCustomerSavingPlanData();
      } else {
        toastIdRef.current = toast({
          title: response.message || 'Error Creating',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const fetchStores = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await StoresApi.List({
        sort: 'name:asc',
        itemsPerPage: 100,
      });
      setStores(response.data.data.list);
    } catch (error) {
      setError('Failed to fetch stores');
    }
    setLoading(false);
  };
  const Createinstallment = async () => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    try {
      let response = await CustomerSavingPlanApi.CreateInstallment({
        planId: planId,
        userid: planData?.user_id,
      });
      response = response.data;
      console.log('response from Customer Saving Plan Installment -', response);
      setLoading(false);
      if (response.status_code === 200) {
        // setPlanData(response?.data);
        setOrdersummary(response?.data);
      } else {
        setPlanData({});
      }
    } catch (err) {
      console.log(err);
    }
  };

  const payInstallmnent = () => {
    console.log('Inside pay installment');
    Createinstallment();
  };

  const redeemAtStore = async (values) => {
    console.log('Inside redeem', values);
    try {
      let response = await CustomerSavingPlanApi.CloseAccount({
        planId: planId,
        userid: planData?.user_id,
        storeId: values.storeId,
      });
      response = response.data;
      console.log(
        'response from Customer Saving Plan Close Account -',
        response
      );

      if (response.status_code === 200) {
        // setPlanData(response?.data);
        setOrdersummary(response?.data);
      } else {
        toastIdRef.current = toast({
          title: response.message,
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const FetchCustomerSavingPlanData = async () => {
    if (!isValidUUID(planId)) {
      setFetchCustomerSavingPlanDataError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await CustomerSavingPlanApi.getById(planId);
      response = response.data;
      // console.log('response from Customer Saving Plan -', response);
      setLoading(false);
      if (response.status_code === 200) {
        setFetchCustomerSavingPlanDataError(false);
        setPlanData(response?.data);
      } else {
        setFetchCustomerSavingPlanDataError(true);
        setPlanData({});
      }
    } catch (err) {
      setFetchCustomerSavingPlanDataError(true);
      console.log(err);
    }
  };

  useEffect(() => {
    FetchCustomerSavingPlanData();
    fetchStores();
  }, []);

  if (orderSummary) {
    console.log('This is order summary', orderSummary);
    return <OrderSummaryPage orderSummary={orderSummary} />;
  }

  if (!permissions?.read) {
    return <NoPermissionsMessage module={Modules.CustomerSavingPlans} />;
  }

  return loading ? (
    <Center
      mt='10rem'
      width='100%'
    // bgColor='red'
    >
      <Spinner size='xl' />
    </Center>
  ) : fetchCustomerSavingPlanDataError ? (
    <PageError />
  ) : (
    <Box mt='8rem' mb='6rem' maxWidth='7xl'>
      <Flex direction='column' gap={8}>
        <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
          <Card display='flex' gap={8}>
            <Flex direction='column' gap={2} width='100%'>
              <Text fontWeight='medium'>Purchasing Customer</Text>
              <Button
                variant='light'
                onClick={() => {
                  GoToCustomerUser(planData?.user_id);
                }}
              >
                <Text fontWeight='bold' mr={2}>
                  {planData?.user_name}
                </Text>
                <MdArrowForward />
              </Button>
            </Flex>

            <Flex direction='column' gap={4} width='100%'>
              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>Category</Text>
                <Text ml={2}>
                  {planData?.category} - {planData?.total_month} months
                </Text>
              </Flex>
              {/* <Flex
                justifyContent='space-between'
                gap={2}>
                <Text fontWeight='medium'>Metal Type</Text>
                <Text>{planData?.metal_type}</Text>
              </Flex> */}
              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>Status</Text>
                <Text>
                  {
                    CspStatus.find(
                      (option) => option.value === planData?.status
                    )?.label
                  }
                </Text>
              </Flex>
              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>Referal Code</Text>
                <Text>
                  {
                    planData?.referal_code ? planData?.referal_code : '--'
                  }
                </Text>
              </Flex>
              <Flex justifyContent="space-between" gap={2}>
                <Text fontWeight="medium">Enroll Branch</Text>

                <Flex direction="column" textAlign="right">
                  <Text fontWeight="semibold">
                    {planData?.prefered_store?.name} ({planData?.prefered_store?.store_code})
                  </Text>

                  <Text fontSize="sm" color="gray.600">
                    {planData?.prefered_store?.address_line1}, {planData?.prefered_store?.address_line2}
                  </Text>

                  <Text fontSize="sm" color="gray.600">
                    {planData?.prefered_store?.city}, {planData?.prefered_store?.state} - {planData?.prefered_store?.pincode}
                  </Text>

                  <Text fontSize="sm" color="gray.500">
                    {planData?.prefered_store?.company_name} ({planData?.prefered_store?.company_code})
                  </Text>
                </Flex>
              </Flex>
            </Flex>
          </Card>
          <Flex direction={{ base: 'column', md: 'row' }} gap={4} width='100%'>
            <Card display='flex' gap={4}>
              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>Start Date</Text>
                <Text>
                  {moment(planData.start_date).format('DD MMM YY, HH:mm')}
                </Text>
              </Flex>
              <Flex justifyContent='space-between' gap={2}>
                <Text fontWeight='medium'>End Date</Text>
                <Text>
                  {moment(planData.end_date).format('DD MMM YY, HH:mm')}
                </Text>
              </Flex>

              <Flex justifyContent='space-between' gap={2}>
                <Text color='brand.500' fontWeight='medium'>
                  Next Due Date
                </Text>
                <Text fontWeight='bold'>
                  {planData.next_due_date &&
                    moment(planData.next_due_date).format('DD MMM YY')}
                </Text>
              </Flex>
            </Card>

            <Card display="flex" flexDirection="column" gap={4} p={4}>
              <Flex direction="column" gap={2}>
                <Text fontWeight="medium">Account Branch</Text>

                <Button
                  variant="light"
                  onClick={() => GoToStore(planData?.store_id)}
                  justifyContent="space-between"
                >
                  <Text fontWeight="bold">
                    {planData?.store?.name} ({planData?.store?.store_code})
                  </Text>
                  <MdArrowForward />
                </Button>
              </Flex>

              <Flex direction="column" gap={1}>
                <Text fontWeight="medium">Branch Location</Text>
                <Text fontSize="sm" color="gray.600">
                  {planData?.store?.address_line1}, {planData?.store?.address_line2}
                </Text>
                <Text fontSize="sm" color="gray.600">
                  {planData?.store?.city}, {planData?.store?.state} - {planData?.store?.pincode}
                </Text>
              </Flex>

              <Flex direction="column" gap={1}>
                <Text fontWeight="medium">Company</Text>
                <Text fontSize="sm" color="gray.600">
                  {planData?.store?.company_name} ({planData?.store?.company_code})
                </Text>
              </Flex>
            </Card>

          </Flex>
        </Flex>

        <Flex direction={{ base: 'column', md: 'row' }} gap={4}>
          <Flex direction='column' gap={3} width='100%'>
            <Text align='center' fontSize='2xl' fontWeight='500'>
              Plan Details
            </Text>

            <Card>
              <Flex direction='column' gap={4}>
                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>Scheme No.</Text>
                  <Text>{planData?.account_number}</Text>
                </Flex>

                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>Installments Paid</Text>
                  <Text>
                    {Math.floor(
                      planData?.total_deposit_amount / planData?.monthly_amount
                    )}
                  </Text>
                </Flex>

                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>Total Amount</Text>
                  <Text>{planData?.total_amount}</Text>
                </Flex>

                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>Amount Deposited</Text>
                  <Text>{planData?.total_deposit_amount}</Text>
                </Flex>

                <Flex justifyContent='space-between' gap={2}>
                  <Text color='brand.500' fontWeight='medium'>
                    Monthly Amount
                  </Text>
                  <Text fontWeight='bold'>{planData?.monthly_amount}</Text>
                </Flex>

                {planData?.virtual_account_number && planData?.virtual_ifsc ? (
                  <>
                    <Divider borderColor='gray.500' />
                    <Flex justifyContent='space-between' gap={2}>
                      <Text fontWeight='medium'>Virtual Account Number</Text>
                      <Text>{planData?.virtual_account_number}</Text>
                    </Flex>
                    <Flex justifyContent='space-between' gap={2}>
                      <Text fontWeight='medium'>Virtual IFSC Code</Text>
                      <Text>{planData?.virtual_ifsc}</Text>
                    </Flex>
                  </>
                ) : (
                  <>
                    <Button
                      colorScheme='blue'
                      alignSelf='flex-center'
                      onClick={CreateVirtualAccount}
                      isLoading={virtualAccountLoading}
                    >
                      Create Virtual Account
                    </Button>
                  </>
                )}
              </Flex>
            </Card>
          </Flex>

          <Flex direction='column' gap={3} width='100%'>
            <Text align='center' fontSize='2xl' fontWeight='500'>
              Nominee Details
            </Text>
            <Card display='flex' height='100%'>
              <Flex direction='column' gap={4}>
                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>Nominee</Text>
                  <Text ml={2}>{planData?.nominee_name}</Text>
                </Flex>
                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>Nominee Relation</Text>
                  <Text>{planData?.nominee_relation}</Text>
                </Flex>

                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>Nominee DOB</Text>
                  <Text ml={2}>
                    {moment(planData?.nominee_dob).format('DD MMM YY, HH:mm')}
                  </Text>
                </Flex>
                <Flex justifyContent='space-between' gap={2}>
                  <Text fontWeight='medium'>Nominee Phone No.</Text>
                  <Text>{planData?.nominee_phone_number}</Text>
                </Flex>
              </Flex>
            </Card>
          </Flex>
        </Flex>
        <Flex direction='column' gap={3}>
          <Flex justifyContent='space-between'>
            <Text fontSize='2xl' fontWeight='500'>
              Paid Installments
            </Text>
            <Flex justifyContent='space-between'>
              {planData?.status === 'RUNNING' &&
                permissions?.read &&
                permissions?.update && (
                  <Button
                    colorScheme='blue'
                    mt={4}
                    margin={1}
                    alignSelf='flex-end'
                    onClick={payInstallmnent}
                  >
                    Pay Installment
                  </Button>
                )}
              {permissions?.read &&
                permissions?.update &&
                permissions?.delete && (
                  <Button
                    colorScheme='blue'
                    mt={4}
                    margin={1}
                    alignSelf='flex-end'
                    onClick={onOpen}
                  >
                    Redeem At Store
                  </Button>
                )}
            </Flex>
          </Flex>
          {planData?.installments?.length > 0 ? (
            <InstallmentsTable
              installments={planData?.installments}
              category={planData?.category}
            />
          ) : (
            <Flex>
              <Text fontWeight='medium'>
                There are no Installments paid yet.
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              <b> Redeem your plan at the Store </b>
            </Text>
            <Formik initialValues={{ storeId: '' }} onSubmit={redeemAtStore}>
              {({ setFieldValue }) => (
                <Form>
                  <Flex direction='column'>
                    <MultiLineSelectField
                      name='storeId'
                      label='Branch Name'
                      options={storeOptions}
                      required
                    //   onChange={(value) => {
                    //     console.log('Value', value);
                    //     setFieldValue('storeId', value?.value);
                    //   }}
                    />
                  </Flex>
                  <ModalFooter>
                    <Button colorScheme='blue' mr={3} type='submit'>
                      Submit
                    </Button>
                    <Button variant='ghost' onClick={onClose}>
                      Cancel
                    </Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default CustomerSavingPlan;
